import React from "react";
import Seo from "../components/Seo";

const UserAgreement = () => {
  return (
    <main className="page legal-page">
      <Seo
        title="User Agreement"
        description="Review the OctoGames user agreement for account and community rules."
        path="/legal/user-agreement"
        keywords="user agreement, octogames agreement, account usage rules"
      />
      <div className="container legal-container">
        <article className="legal-card">
          <h1 className="legal-title">User Agreement</h1>
          <p className="legal-intro">
            Last updated: February 14, 2026
          </p>
          <p className="legal-copy">
            This User Agreement ("Agreement") defines the rules for creating and using an OctoGames
            account and interacting with Website features. By registering an account or using
            account-based functionality, you agree to this Agreement.
          </p>

          <h2 className="legal-section-title">1. Operator and Scope</h2>
          <p className="legal-copy">
            OctoGames is operated by a private individual located in Ukraine ("Operator", "we",
            "us", or "our"). This Agreement applies to user accounts, profile features, favorites,
            and related interactions on the Website.
          </p>

          <h2 className="legal-section-title">2. Account Eligibility</h2>
          <p className="legal-copy">
            You may create and use an account only if you have legal capacity in your jurisdiction.
            If you are below the age of majority, a parent or legal guardian must supervise your use.
          </p>

          <h2 className="legal-section-title">3. Account Registration and Security</h2>
          <p className="legal-copy">
            You agree to provide accurate information and keep it up to date. You are responsible
            for maintaining confidentiality of your login credentials and for all actions performed
            under your account.
          </p>
          <ul className="legal-list">
            <li>Do not share credentials with unauthorized persons.</li>
            <li>Do not create accounts using false identity information.</li>
            <li>Notify us immediately about suspected unauthorized access.</li>
          </ul>

          <h2 className="legal-section-title">4. Acceptable User Conduct</h2>
          <p className="legal-copy">
            You agree to use the Website lawfully and respectfully. You must not:
          </p>
          <ul className="legal-list">
            <li>Attempt unauthorized access to accounts, systems, or data.</li>
            <li>Use bots, scripts, scraping tools, or exploitative automation.</li>
            <li>Upload or transmit malware, harmful code, or abusive content.</li>
            <li>Disrupt service stability, security, or availability.</li>
            <li>Violate intellectual property, privacy, or other legal rights.</li>
          </ul>

          <h2 className="legal-section-title">5. Game Content and Third Parties</h2>
          <p className="legal-copy">
            The Website includes embedded games from third-party providers, including
            OctoGames.io partners. Third-party games may have separate rules,
            policies, and technical behavior that we do not fully control.
          </p>

          <h2 className="legal-section-title">6. User Data and Privacy</h2>
          <p className="legal-copy">
            Account and usage data are handled according to our Privacy Policy. By using account
            features, you acknowledge that your data may be processed for authentication, favorites,
            service operation, security, and support.
          </p>

          <h2 className="legal-section-title">7. Suspension and Termination</h2>
          <p className="legal-copy">
            We may suspend, restrict, or terminate account access when we reasonably believe you
            violated this Agreement, applicable law, or platform security requirements.
          </p>
          <p className="legal-copy">
            You may stop using your account at any time. Some records may be retained where required
            for legal, security, or operational purposes.
          </p>

          <h2 className="legal-section-title">8. Intellectual Property</h2>
          <p className="legal-copy">
            Website branding, design, and original materials belong to the Operator or are used
            under license. Embedded games and related assets belong to their respective owners.
            This Agreement does not transfer ownership rights to users.
          </p>

          <h2 className="legal-section-title">9. Service Availability</h2>
          <p className="legal-copy">
            We may update, limit, or discontinue account features at any time. We do not guarantee
            uninterrupted operation, permanent feature availability, or error-free access.
          </p>

          <h2 className="legal-section-title">10. Disclaimers and Liability</h2>
          <p className="legal-copy">
            To the maximum extent permitted by law, account features are provided "as is" and
            "as available" without warranties of any kind. We are not liable for indirect,
            incidental, consequential, or special damages related to use of the Website.
          </p>

          <h2 className="legal-section-title">11. Governing Law</h2>
          <p className="legal-copy">
            This Agreement is governed by the laws of Ukraine, excluding conflict of law principles.
            Disputes are subject to competent courts of Ukraine unless mandatory consumer law in
            your jurisdiction states otherwise.
          </p>

          <h2 className="legal-section-title">12. Changes to This Agreement</h2>
          <p className="legal-copy">
            We may update this Agreement from time to time. Updated versions will be posted on this
            page with a revised "Last updated" date. Continued use of account features after
            changes become effective means you accept the updated Agreement.
          </p>

          <h2 className="legal-section-title">13. Contact</h2>
          <p className="legal-copy">
            For account or legal questions related to this User Agreement, contact:
            {" "}
            <a href="mailto:support@octogames.io">support@octogames.io</a>.
          </p>
        </article>
      </div>
    </main>
  );
};

export default UserAgreement;
